export default __webpack_public_path__ + "static/media/one.53711ecc.svg";